const enum ActionFilter {
  Vod = 1,
  Program = 2,
  Series = 4,
  Channel = 8,
  Schedule = 16,
  Article = 32,
  Bundle = 64,
  Product = 128,
  Subscription = 256,
  Page = 512,
}

export const ottActionFilter = `${
  ActionFilter.Vod |
  ActionFilter.Program |
  ActionFilter.Series |
  ActionFilter.Channel |
  ActionFilter.Schedule |
  ActionFilter.Article |
  ActionFilter.Bundle |
  ActionFilter.Page
}`;
